/**
 * Manage focus on a parent element that contains and input and button
 * that are aligned
 */

const onFocus = (event) => {
  event.target.parentNode.classList.add('has-focus');
};

const onBlur = (event) => {
  event.target.parentNode.classList.remove('has-focus');
};

const addonInput = {
  init() {
    const inputs = document.querySelectorAll('[data-module="addon-input"]');

    if (inputs) {
      inputs.forEach((input) => {
        input.addEventListener('focus', onFocus);
        input.addEventListener('blur', onBlur);
      });
    }
  },
};

export default addonInput;
